import { z } from 'zod';
import { errorCodeSchema } from '../errors.ts';
import { actorSchema, isoDateTimeSchema } from './common.ts';

export const auditActionSchema = z.enum([
  'submission.start',
  'submission.cancel',
  'run.retry',
  'decision.submit',
  'note.add',
  'preferences.update',
  'inbox.reply',
  'inbox.close',
  'inbox.reopen',
  'inbox.triage_start',
  'inbox.triage_review',
]);
export type AuditAction = z.infer<typeof auditActionSchema>;

export const auditOutcomeSchema = z.enum(['ok', 'rejected', 'error']);
export type AuditOutcome = z.infer<typeof auditOutcomeSchema>;

export const auditEventSchema = z.object({
  id: z.string(),
  at: isoDateTimeSchema,
  actor: actorSchema,
  action: auditActionSchema,
  requestId: z.string().optional(),
  workflowId: z.string().optional(),
  outcome: auditOutcomeSchema,
  errorCode: errorCodeSchema.optional(),
  correlationId: z.string(),
});
export type AuditEvent = z.infer<typeof auditEventSchema>;
